import React, { useEffect, useState } from 'react';
import { connect } from 'react-redux';
import { clearErrors, getAllActividades, getActividades, postActividades } from '../../actions';
import { messageTypeEnum } from '../../enum';
import { Card } from 'semantic-ui-react'
import SearchActividades from '../search/searchActividades';
import BasicMessage from '../messages/basicMessage';

const ActividadEconomica = (props) => {
	const { allActividadesState, errorState, token, cedula, actividadesState, emisorId } = props;
	const [mgType, setMgType] = useState('');
	const [message, setMessage] = useState('');
	const [actividades, setActividades] = useState([]);


	useEffect(() => {
		props.clearErrors();
		if (token !== null) {
			props.getAllActividades(token);
		}
	}, []);

	useEffect(() => {
		props.clearErrors();
		if (token !== null && cedula !== '') {
			props.getActividades(token, cedula);
		}
	}, [cedula]);

	useEffect(() => {
		props.clearErrors();
		if (actividadesState?.actividades) {
			setActividades(actividadesState?.actividades)
		}
	}, [actividadesState]);

	useEffect(() => {
		if (errorState && errorState.error !== null) {
			setMgType(errorState?.error ? messageTypeEnum.error : messageTypeEnum.success);
			setMessage(errorState.message);
		}
		else {
			setMgType('');
		}
	}, [errorState]);

	const addActividada = (data) => {
		setActividades([...actividades, { EmisorId: emisorId, ...data }]);
	}

	const closeMessage = () => {
		props.clearErrors();
	}

	const renderAllActividades = () => {
		return (
			<>
				<SearchActividades
					onClick={(data) => addActividada(data)}
					source={allActividadesState?.allActividades} />
			</>
		);
	};

	const removeActividad = (actividad) => {
		setActividades([...actividades.filter(item => item.CodigoActividad !== actividad.CodigoActividad)]);
	}

	const saveActividades = () => {
		props.postActividades(token, actividades);
	}

	const renderActividadesSelected = () => {
		if (actividades.length > 0) {
			return (
				actividades.map((item, index) =>
					<div key={index} className="ui row fluid grid">
						<div className="two wide column centered row">
							<button onClick={() => removeActividad(item)} className="ui icon button">
								<i className="trash alternate icon"></i>
							</button>
						</div>
						<div className="fourteen wide column fliud">
							<label>
								{`${item.CodigoActividad} - ${item.Actividad}`}
							</label>
						</div>
					</div>
				)
			);
		}

		return <span>Debe seleccionar una actividad económica</span>;
	};

	return (
		<>
			<div className="ui stackable grid" >
				<div className="eight wide column">
					<Card fluid>
						<Card.Content Header>
							<Card.Header>Actividades económicas seleccionadas</Card.Header>
						</Card.Content>
						<Card.Content>
							{renderActividadesSelected()}
						</Card.Content>
					</Card>
				</div>
				<div className="eight wide column">
					<Card fluid>
						<Card.Content>
							<Card.Header>Listado de actividades económicas</Card.Header>
						</Card.Content>
						<Card.Content>
							{renderAllActividades()}
						</Card.Content>
					</Card>
				</div>
			</div>
			<div className="ui right aligned grid">
				<div className="sixteen wide column">
					<button className="ui button primary"
						onClick={() => saveActividades()}>Guardar</button>
				</div>
			</div>
			<BasicMessage message={message} type={mgType} onClick={() => closeMessage()} />
		</>
	);
};


const mapStateToProps = (state) => {
	return {
		errorState: state.errorState,
		allActividadesState: state.allActividadesState,
		actividadesState: state.actividadesState,
	};
}

export default connect(mapStateToProps,
	{
		clearErrors,
		getAllActividades,
		getActividades,
		postActividades
	}
)(ActividadEconomica);